import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { answerQuiz, answerSurvey } from "../../../../store/thubMethods";
import styles from "../../../../styles/Poll.module.scss";

const PollsBox = ({ data, currentQuest, setCurrentQuest, index }) => {
  const [selectedChoices, setSelectedChoices] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.length !== 0 && data?.length === selectedChoices.length) {
      handleSubmitPolls();
      //   console.log("handleSubmitPolls");
    }
  }, [selectedChoices]);

  const handleSubmitPolls = async () => {
    // console.log("handleSubmitPolls running..");

    dispatch(answerSurvey(selectedChoices, navigate));
  };
  const handleChoiceClick = (item) => {
    // console.log(item, "handleChoiceClick");
    setSelectedChoices([
      ...selectedChoices,
      { question: data[currentQuest]?.id, answer: item.id },
    ]);
    setCurrentQuest(currentQuest + 1);
  };
  //   console.log("data.length", data.length);
  // console.log("selectedChoices", selectedChoices.length);
  // console.log("selectedChoices", selectedChoices);

  {
    // console.log(currentQuest, "currentQuest");
  }
  // console.log(data, "dataaaaaa");
  return (
    <>
      {/* {console.log(data, "dataaaaaa")} */}
      <div className="d-flex h-75 align-items-end">
        <div className={styles.questionCont}>
          <h3 className="mb-4">
            {currentQuest + 1 + ") "}
            {data[currentQuest]?.question && data[currentQuest]?.question + "?"}
          </h3>
          <ul className={styles.questionBox}>
            {data &&
              data[currentQuest]?.choices.map((item, i) => (
                <li
                  onClick={() => {
                    handleChoiceClick(item);
                  }}
                  key={i}
                  className="curosr-pointer"
                >
                  <label className="me-2">
                    {i === 0
                      ? "a)"
                      : i === 1
                      ? "b)"
                      : i === 2
                      ? "c)"
                      : i === 3
                      ? "d)"
                      : "e"}
                  </label>{" "}
                  <p>{item.choice}</p>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <div className="text-end mt-3"></div>
    </>
  );
};

export default PollsBox;
